//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    NOTES_DELETE_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    notesDeleteResult,
} from 'Redux/actions';

function* deleteNote({ payload }) {
    try {
        let QUERY = `
            mutation deleteEntityNote ($id: Int!) {
                result: deleteEntityNote (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(notesDeleteResult({ delete: data?.result }))

    } catch (exc) {
        yield put(notesDeleteResult({ delete: false }))
        ExceptionManager(exc, 'Modules/keysFobs/.components/deleteNote/redux/saga', 'deleteNote');
    }
}

function* watchCatalogRequests() {
    yield takeEvery(NOTES_DELETE_REQUEST, deleteNote);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchCatalogRequests)
    ]);
}